import { c as _c } from "react/compiler-runtime";
import { RuleStepHeader } from 'modules/automation-rules/components/rule-step-header';
import { triggerActionLocoKeys, triggerDescriptionLocoKeys } from 'modules/automation-rules/triggers/constants/trigger-loco-keys';
import { AutomationRuleTriggersDataEnum, AutomationRuleTriggersEnum } from 'modules/automation-rules/triggers/enums/trigger-enum';
import { TriggersDataInterface, useTriggersData } from 'modules/automation-rules/triggers/hooks/use-triggers-data';
import { AutomationRulesTriggersEditType } from 'modules/automation-rules/triggers/types/automation-rule-triggers-edit-interface';
import { getTriggerIcon } from 'modules/automation-rules/triggers/utils/get-trigger-icon';
import React, { type JSX } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
export interface WrapperChildrenPropsInterface {
  renderTriggerLabel: ({
    label,
    additionalLabel
  }: {
    label: string;
    additionalLabel?: JSX.Element;
  }) => JSX.Element;
  onOpen: (slug: AutomationRuleTriggersDataEnum) => void;
  onClear: (slug: AutomationRuleTriggersDataEnum) => void;
  data: TriggersDataInterface;
}
type ChildrenType = (args: WrapperChildrenPropsInterface) => JSX.Element;
interface RuleTriggerWrapperProps {
  trigger: AutomationRulesTriggersEditType;
  children: ChildrenType;
  onDelete: () => void;
}
const RuleTriggerWrapper = t0 => {
  const $ = _c(40);
  const {
    trigger,
    children,
    onDelete
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const blogId = trigger.type === AutomationRuleTriggersEnum.blog_page_form_subscribed ? trigger.blog.id : undefined;
  const blogEntity = trigger.type === AutomationRuleTriggersEnum.blog_page_form_subscribed ? trigger.page.type : undefined;
  const formSubscribeFunnelId = trigger.type === AutomationRuleTriggersEnum.form_subscribed ? trigger.funnelStep.funnel.id : undefined;
  const newSaleFunnelId = trigger.type === AutomationRuleTriggersEnum.new_sale ? trigger.funnelStep.funnel.id : undefined;
  const cancelSaleFunnelId = trigger.type === AutomationRuleTriggersEnum.sale_canceled ? trigger.funnelStep.funnel.id : undefined;
  const pageVisitedFunnelId = trigger.type === AutomationRuleTriggersEnum.page_visited ? trigger.funnelStep.funnel.id : undefined;
  const webinarFunnelId = trigger.type === AutomationRuleTriggersEnum.registered_to_webinar ? trigger.webinar.registrationFunnelStep.funnel.id : undefined;
  const triggerCourseId = trigger.type === AutomationRuleTriggersEnum.module_completed || trigger.type === AutomationRuleTriggersEnum.lecture_completed ? trigger.course.id : undefined;
  const triggerModuleId = trigger.type === AutomationRuleTriggersEnum.lecture_completed ? trigger.module?.id : undefined;
  const subscriptionFailedFunnelId = trigger.type === AutomationRuleTriggersEnum.subscription_payment_failed ? trigger.funnelStep.funnel.id : undefined;
  const triggerMailingId = trigger.type === AutomationRuleTriggersEnum.email_link_clicked ? trigger.mailing.id : undefined;
  const triggerDigitalStoreId = trigger.type === AutomationRuleTriggersEnum.digital_store_form_subscribed ? trigger.digitalStore.id : undefined;
  const triggerWebsiteId = trigger.type === AutomationRuleTriggersEnum.website_form_subscribed ? trigger.website.id : undefined;
  const triggerWebsitePageId = trigger.type === AutomationRuleTriggersEnum.website_form_subscribed ? trigger.website.websitePage?.pageContentId : undefined;
  let t1;
  if ($[0] !== blogEntity || $[1] !== blogId || $[2] !== cancelSaleFunnelId || $[3] !== formSubscribeFunnelId || $[4] !== newSaleFunnelId || $[5] !== pageVisitedFunnelId || $[6] !== subscriptionFailedFunnelId || $[7] !== trigger.type || $[8] !== triggerCourseId || $[9] !== triggerDigitalStoreId || $[10] !== triggerMailingId || $[11] !== triggerModuleId || $[12] !== triggerWebsiteId || $[13] !== triggerWebsitePageId || $[14] !== webinarFunnelId) {
    t1 = {
      trigger: trigger.type,
      blogId,
      formSubscribeFunnelId,
      newSaleFunnelId,
      cancelSaleFunnelId,
      pageVisitedFunnelId,
      blogEntity,
      webinarFunnelId,
      triggerCourseId,
      triggerModuleId,
      triggerMailingId,
      subscriptionFailedFunnelId,
      triggerDigitalStoreId,
      triggerWebsiteId,
      triggerWebsitePageId
    };
    $[0] = blogEntity;
    $[1] = blogId;
    $[2] = cancelSaleFunnelId;
    $[3] = formSubscribeFunnelId;
    $[4] = newSaleFunnelId;
    $[5] = pageVisitedFunnelId;
    $[6] = subscriptionFailedFunnelId;
    $[7] = trigger.type;
    $[8] = triggerCourseId;
    $[9] = triggerDigitalStoreId;
    $[10] = triggerMailingId;
    $[11] = triggerModuleId;
    $[12] = triggerWebsiteId;
    $[13] = triggerWebsitePageId;
    $[14] = webinarFunnelId;
    $[15] = t1;
  } else {
    t1 = $[15];
  }
  const {
    triggersData,
    setShouldFetch
  } = useTriggersData(t1);
  const renderTriggerLabel = _temp;
  const t2 = triggerDescriptionLocoKeys[trigger.type];
  let t3;
  if ($[16] !== t || $[17] !== t2) {
    t3 = t(t2);
    $[16] = t;
    $[17] = t2;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  let t4;
  if ($[19] !== trigger.type) {
    t4 = getTriggerIcon(trigger.type);
    $[19] = trigger.type;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  const t5 = triggerActionLocoKeys[trigger.type];
  let t6;
  if ($[21] !== t || $[22] !== t5) {
    t6 = t(t5);
    $[21] = t;
    $[22] = t5;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== onDelete || $[25] !== t3 || $[26] !== t4 || $[27] !== t6) {
    t7 = <RuleStepHeader description={t3} icon={t4} onDelete={onDelete} title={t6} />;
    $[24] = onDelete;
    $[25] = t3;
    $[26] = t4;
    $[27] = t6;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  let t8;
  let t9;
  if ($[29] !== setShouldFetch) {
    t8 = slug => setShouldFetch(prev => ({
      ...prev,
      [slug]: true
    }));
    t9 = slug_0 => setShouldFetch(prev_0 => ({
      ...prev_0,
      [slug_0]: false
    }));
    $[29] = setShouldFetch;
    $[30] = t8;
    $[31] = t9;
  } else {
    t8 = $[30];
    t9 = $[31];
  }
  let t10;
  if ($[32] !== children || $[33] !== t8 || $[34] !== t9 || $[35] !== triggersData) {
    t10 = children({
      data: triggersData,
      onOpen: t8,
      onClear: t9,
      renderTriggerLabel
    });
    $[32] = children;
    $[33] = t8;
    $[34] = t9;
    $[35] = triggersData;
    $[36] = t10;
  } else {
    t10 = $[36];
  }
  let t11;
  if ($[37] !== t10 || $[38] !== t7) {
    t11 = <div className="flex flex-col gap-4">{t7}{t10}</div>;
    $[37] = t10;
    $[38] = t7;
    $[39] = t11;
  } else {
    t11 = $[39];
  }
  return t11;
};
export default RuleTriggerWrapper;
function _temp(t0) {
  const {
    label,
    additionalLabel
  } = t0;
  return <><span>{label}</span>{additionalLabel ? <span className="order-1 ml-1.5 flex h-5 items-center gap-1.5 self-center [&_svg]:size-4 [&_svg]:shrink-0">{additionalLabel}</span> : null}</>;
}